import React, { Component } from 'react';

import { Button } from 'react-bootstrap';
import md5 from 'md5';
import SignatureCanvas from 'react-signature-canvas';

require(`../assets/${process.env.PAGE}/css/components/signature-field.css`);

class SignatureField extends Component {
  constructor(props){
    super(props);

    this.state = {
      signaturePad: false,
      signature: {
        blobFile: null,
        md5Sum: null,
      }
    }

    this.signatureCanvasRef = null;

    this.showSignaturePad = this.showSignaturePad.bind(this);
    this.hideSignaturePad = this.hideSignaturePad.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.handleClean = this.handleClean.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

    showSignaturePad() {
      this.setState({ signaturePad: true });
    }

    hideSignaturePad() {
      this.setState({ signaturePad: false });
    }

    handleChange(fileData) {
      const { onChange } = this.props;
      if (onChange) {
        onChange(fileData);
      }
    }

    handleConfirmation() {
      if (this.signatureCanvasRef) {
        if (!this.signatureCanvasRef.isEmpty()) {
          const currentCanvas = this.signatureCanvasRef.getTrimmedCanvas();
          currentCanvas.toBlob(
            (blob) => {
              this.handleChange({
                blobFile: blob,
                md5Sum: md5(blob),
                dataurl: currentCanvas.toDataURL(),
              });
              this.hideSignaturePad();
            }
          );
        }
      }
    }

    handleClean() {
      if (this.signatureCanvasRef) {
        this.signatureCanvasRef.clear();
        this.hideSignaturePad();
      }
    }

    render() {

      const { signaturePad } = this.state;
      const { className, disabled } = this.props;

      const ConfirmButtons = (
        <div>
          <button className='btn btn-primary action-button' style={{margin: '10px'}} onClick={this.handleConfirmation}><span className="glyphicon glyphicon-ok" aria-hidden="true"></span></button>
          <button className='btn btn-primary action-button' style={{margin: '10px'}} onClick={this.handleClean}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
        </div>
      );

      return !signaturePad ?
      (<Button className={`btn btn-warning btn-sm pd-simple-button ${className} `}  onClick={this.showSignaturePad} disabled={disabled}>Firmar</Button>) :
      (<div
          style={
            {
              position: "fixed",
              left: 0,
              top: 0,
              height: "100vh",
              width: "100%",
              background: "#000",
              zIndex: "1000",
            }
          }
        >
          <div
            style={
              {
                position:"relative",
                height: "100%",
                width: "100%",
                overflow:"hidden",
                textAlign: "center",
              }
            }
          >
            <SignatureCanvas
              backgroundColor="#ffff"
              canvasProps={
                {
                  width: 350,
                  height: 190,
                  style: {
                    position: "absolute",
                    transform: "translateX(-50%)",
                    top: "40%",
                  }
                }
              }
              clearOnResize={false}
              ref={(ref) => { this.signatureCanvasRef = ref; }}
            />
            <div
              style={{
                position: "absolute",
                marginLeft: "50%",
                transform: "translateX(-50%)",
                top: "5%",
                textAlign:"center",
              }}>
                <img
                  src={require(`../assets/common/signature/signature.png`)}
                  style={{
                    maxHeight: "48px",
                    maxWidth: "63px",
                }}/>
              <span>
                <p>
                  <h3 className={'signature-field-text'}>
                    {this.props.headerTitle}
                  </h3>
                </p>
              </span>
            </div>
            <div
              style={{
                position: "absolute",
                marginLeft: "50%",
                transform: "translateX(-50%)",
                bottom: "4%",
                textAlign:"center",
                color: "#FFF",
              }}>
              <span>
                <p>
                  <h3 className={'signature-field-text'}>
                    Por favor firmá dentro del recuadro blanco
                  </h3>
                </p>
              </span>
              {ConfirmButtons}
            </div>
          </div>
        </div>);
    }
}

export default SignatureField;


/** WEBPACK FOOTER **
 ** ./src/components/SignatureField.js
 **/